export const ngdUserManagementConfig = (window as any)
    .ngdUserManagementConfig as { apiUrl: string };

const apiRoot = process.env.isLocalhost ? ngdUserManagementConfig.apiUrl : "/__app/"

export const userManagementApiEndpoints = {
    publicCustomers: customerId =>
        `${apiRoot}v1/public/settings/company${
            customerId ? "?customerId=" + customerId : ""
        }`,

    customerConfig: customerId =>
        `${apiRoot}v1/public/settings/SubscriptionsPage${
            customerId ? "?customerId=" + customerId : ""
        }`,
};
